const TRAVEL_AI = [
  { label: "Travel Tech", href: "#travel-tech" },
  { label: "AI Products", href: "#ai-products" },
  { label: "Proof", href: "#proof" },
];

const SERVICES = [
  { label: "Experience Design", href: "#services" },
  { label: "Technology", href: "#services" },
  { label: "Digital Marketing", href: "#services" },
  { label: "Creative & Tools", href: "#services" },
];

export default function Footer() {
  return (
    <footer className="border-t border-white/[0.08] bg-ink pb-10 pt-16">
      <div className="mx-auto max-w-[1160px] px-6">
        <div className="grid gap-12 md:grid-cols-[1.4fr_0.7fr_0.7fr_1fr]">
          <div>
            <p className="text-[19px] font-medium text-white" data-testid="footer-logo">
              Infinity House of Technology
            </p>
            <p className="mt-3 text-[15px] text-white/45">AI &amp; technology company · Global</p>
          </div>
          <FooterCol title="Travel & AI" links={TRAVEL_AI} />
          <FooterCol title="Services" links={SERVICES} />
          <div>
            <p className="text-[15px] text-white/40">Contact</p>
            <ul className="mt-6 space-y-3.5 text-[16px]">
              <li>
                <a
                  href="mailto:info@infinityhouseoftechnology.com"
                  data-testid="footer-email-link"
                  className="text-white/85 transition-colors hover:text-white"
                >
                  info@infinityhouseoftechnology.com
                </a>
              </li>
              <li>
                <a
                  href="tel:+918921552108"
                  data-testid="footer-phone-link"
                  className="text-white/85 transition-colors hover:text-white"
                >
                  +91 89215 52108
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com"
                  target="_blank"
                  rel="noreferrer"
                  data-testid="footer-linkedin-link"
                  className="text-white/85 transition-colors hover:text-white"
                >
                  LinkedIn
                </a>
              </li>
              <li>
                <span className="text-white/85" data-testid="footer-address">
                  Office address: Door No. 65/1448, Madhurima, Kaloor, Kochi, Kerala
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-24 flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
          <p className="text-[15px] text-white/40" data-testid="footer-copyright">
            © 2026 Infinity House of Technology LLP · LLPIN ADA-6498
          </p>
          <a
            href="#top"
            data-testid="footer-privacy-link"
            className="text-[15px] text-white/40 transition-colors hover:text-white"
          >
            Privacy Policy
          </a>
        </div>
      </div>
    </footer>
  );
}

function FooterCol({ title, links }) {
  return (
    <div>
      <p className="text-[15px] text-white/40">{title}</p>
      <ul className="mt-6 space-y-3.5 text-[16px]">
        {links.map((l) => (
          <li key={l.label}>
            <a
              href={l.href}
              data-testid={`footer-link-${l.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="text-white/85 transition-colors hover:text-white"
            >
              {l.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
